export const stats = [
  { value: '8', label: 'Volumi Completi' },
  { value: '500+', label: 'Pagine di Risorse' },
  { value: '80', label: 'Unità Didattiche' },
  { value: '100%', label: "Pronto per l'Aula" },
]

export const beforeItems = [
  'Passare le domeniche a pianificare ogni singola lezione.',
  'Cacciare schede su Pinterest o Google che non si adattano mai alla tua classe.',
  'Nessuna progressione chiara anno dopo anno: ti senti sempre al punto di partenza.',
  'Dover creare da zero test di verifica e cercare le soluzioni.',
  'Sentirti frustrato perché la burocrazia ti toglie il piacere di insegnare.',
]

export const afterItems = [
  'Un intero anno mappato e organizzato per ogni classe.',
  'Lezioni, esercizi e schede pronti per la stampa o la LIM.',
  'Un curriculum a spirale logico dai 6 ai 14 anni.',
  'Insegnamento semplice passo dopo passo, anche se non sei uno specialista.',
  'Verifiche integrate e chiavi di correzione incluse per risparmiare settimane di lavoro.',
]

export const recognizeItems = [
  'Non hai più tempo per pianificare lezioni che siano davvero coinvolgenti.',
  'Vedi gli studenti annoiarsi con le solite vecchie attività ripetitive.',
  'Gestire livelli diversi nella stessa classe ti sembra una missione impossibile.',
  'Insegni musica fuori dalla tua specializzazione e hai paura di sbagliare.',
  'Non trovi nulla che funzioni davvero sia per i piccoli che per i ragazzi delle medie.',
]

export type Volume = {
  number: number
  title: string
  text: string
}

export const primaryVolumes: Volume[] = [
  {
    number: 1,
    title: 'Il Risveglio Sonoro',
    text: 'Esplorazione del suono, del silenzio e primi passi ritmici.',
  },
  {
    number: 2,
    title: 'Ritmo e Movimento',
    text: 'La pulsazione e il corpo come primo strumento.',
  },
  {
    number: 3,
    title: 'Il Linguaggio delle Note',
    text: 'Lettura e scrittura facilitata sul pentagramma.',
  },
  {
    number: 4,
    title: 'Emozioni in Musica',
    text: 'Ascolto attivo e viaggio tra i grandi compositori.',
  },
  {
    number: 5,
    title: 'Piccoli Compositori',
    text: 'Storia della musica e creazione di brani originali.',
  },
]

export const secondaryVolumes: Volume[] = [
  {
    number: 6,
    title: 'Percorsi per la Secondaria',
    text: 'Approfondimento dei generi, tecnica e analisi.',
  },
  {
    number: 7,
    title: 'Verifiche e Soluzioni',
    text: 'Il tuo archivio completo per valutare in un secondo.',
  },
  {
    number: 8,
    title: 'Programmazione Annuale',
    text: 'Traguardi e obiettivi scritti mese per mese per la tua burocrazia.',
  },
]

export const bonuses = [
  {
    title: 'Kit "Prima Lezione Perfetta"',
    text: "Aggancia l'attenzione degli studenti dai primi 60 secondi e stabilisci la tua autorità con gioia.",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/0851c1c2-48e2-4a81-aeec-b798ecec9d7e.jpg',
  },
  {
    title: 'Banca di Cues "Il Docente che Ispira"',
    text: 'Le parole esatte da usare per spiegare ritmo e armonia in modo che tutti capiscano al primo colpo.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/ddfda7ee-1054-43f5-8d72-559c4fa2ce4a.jpg',
  },
  {
    title: 'Sistema "Progresso Visibile"',
    text: 'Modelli di autovalutazione e certificati. Quando i genitori vedono il progresso, il tuo valore raddoppia.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/931a0509-2d07-4f11-8eb8-9f302c8d5d78.jpg',
  },
  {
    title: 'Guida "Classi di Gruppo Senza Caos"',
    text: 'Il metodo per gestire 25 strumenti senza perdere il controllo della classe.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/0b8b9774-9e2d-43d6-87e4-dbab85ee543a.jpg',
  },
  {
    title: 'Kit "Anti-Cancellazioni e Motivazione"',
    text: 'Strategie psicologiche per mantenere gli studenti motivati e ridurre l\u2019assenteismo.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/1c1a5415-14c6-4827-8d87-8cd1ac2a1e26.jpg',
  },
]

export const offerRows = [
  { label: 'Musica Pronta (8 Volumi)', value: '€197' },
  { label: '5 Bonus Strategici', value: '€185' },
]

export const testimonials = [
  {
    quote:
      'È esattamente quello di cui avevo bisogno. La programmazione annuale da sola vale il prezzo. Ho finalmente recuperato le mie domeniche.',
    name: 'Sara M.',
    role: 'Insegnante Scuola Primaria',
  },
  {
    quote:
      'Le schede sono bellissime e i ragazzi delle medie non si annoiano. Un materiale di qualità rara in Italia.',
    name: 'Giacomo T.',
    role: 'Docente di Musica',
  },
]

export const faqs = [
  {
    q: 'In che formato sono i materiali?',
    a: 'Sono PDF ad alta risoluzione pronti da stampare o proiettare sulla LIM.',
  },
  {
    q: 'È adatto a chi non ha basi musicali forti?',
    a: 'Sì, è progettato per guidare il docente passo dopo passo.',
  },
  {
    q: 'Come ricevo il materiale?',
    a: 'Immediatamente dopo il pagamento via email.',
  },
  {
    q: 'Posso usarlo su tablet?',
    a: 'Sì, i file sono compatibili con qualsiasi dispositivo digitale.',
  },
]

export const heroGuarantees = [
  'Download digitale istantaneo',
  'PDF pronti per la stampa',
  'Pagamento unico',
]

export const footerLinks = ['Termini e Condizioni', 'Privacy Policy', 'Contatti']
